import { render, staticRenderFns } from "./input-text.vue?vue&type=template&id=64ba23a0&scoped=true&"
import script from "./input-text.vue?vue&type=script&lang=js&"
export * from "./input-text.vue?vue&type=script&lang=js&"
import style0 from "./input-text.vue?vue&type=style&index=0&id=64ba23a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba23a0",
  null
  
)

export default component.exports